import { QaroniMatDialogAnimationToEnum } from './qaroni-mat-dialog-animation-to';
import { QaroniMatDialogDirectionEnum } from './qaroni-mat-dialog-direction.enum';

export const QaroniMatDialogConfigDataAnimateRTL = {
  animation: { to: QaroniMatDialogAnimationToEnum.LEFT },
  direction: QaroniMatDialogDirectionEnum.RTL,
  height: '100%',
  position: { rowEnd: '0' },
  width: '600px',
};

export const QaroniMatDialogConfigDataAnimateRTLSm = {
  animation: { to: QaroniMatDialogAnimationToEnum.LEFT },
  direction: QaroniMatDialogDirectionEnum.RTL,
  height: '100%',
  position: { rowEnd: '0' },
  width: '400px',
};

export const QaroniMatDialogConfigDataAnimateRTLXs = {
  animation: { to: QaroniMatDialogAnimationToEnum.LEFT },
  direction: QaroniMatDialogDirectionEnum.RTL,
  height: '100%',
  position: { rowEnd: '0' },
  width: '400px',
};

export const QaroniMatDialogConfigDataSmall = {
  width: '400px',
};

export const QaroniMatDialogConfigDataContentCenter = {
  height: '300px',
  width: '450px',
};
